import axios from "axios";
import Cookies from "js-cookie";
import { msalConfig } from "./AuthConf";
import { clearCookieKeys } from "./utilFunctions";
import { toast } from "react-toastify";

const tokenExpire = () => {
  clearCookieKeys();
  window.location.href = String(msalConfig.auth.postLogoutRedirectUri);
};
export const setAxiosInterceptors = (instance) => {
  const token = Cookies.get("token");
  instance.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      } else {
        toast.error("Token expire");
        tokenExpire();
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  instance.interceptors.response.use(
    (response) => {
      if (response?.data.statusCode === 401) {
        tokenExpire();
      }
      return response;
    },
    (error) => {
      if (
        error.response &&
        (error?.response?.statusCode === 401 ||
          error?.response?.data?.statusCode === 401)
      ) {
        tokenExpire();
      }
      return Promise.reject(new Error(error));
    }
  );
};

export const axiosClient = (baseURL) => {
  const axiosInstance = axios.create({
    baseURL: baseURL,
    validateStatus: (status) => {
      return status >= 200 && status < 600;
    },
  });
  setAxiosInterceptors(axiosInstance);
  return axiosInstance;
};

export const axiosRequest = () => {
  const axiosInstance = axios.create();
  setAxiosInterceptors(axiosInstance);
  return axiosInstance;
};

export const axiosWithoutToken = () => {
  return axios.create();
};

export const axiosRequestWithValidation = () => {
  const axiosInstance = axios.create({
    validateStatus: (status) => {
      return status >= 200 && status < 600;
    },
  });
  setAxiosInterceptors(axiosInstance);
  return axiosInstance;
};
